export const ACCESS_TOKEN_KEY = 'access_token';
export const ANALYTICS_ID_KEY = 'analytics_id';
export const ROLES_KEY = 'roles';
export const USER_META_KEY = 'userMeta';

export const TOAST_ERROR_INVALID_USERNAME_OR_PASSWORD = 'Invalid username or password';


// WEBPACK FOOTER //
// ./src/features/login/constants.js